export class ContaBanco {
    id: number;
    descricaoConta: string;
    agencia: string;
    conta: string;
    digitoConta: string;
    carteiraPadrao: string;
    tipoCarteiraPadrao: number;
    variacaoCarteiraPadrao: string;
    tipoFormaCadastramento: number;
    tipoImpressaoBoleto: number;
    operacaoConta: string;

    constructor(
        id: number,
        descricaoConta: string = "",
        agencia: string = "",
        conta: string = "",
        digitoConta: string = "",
        carteiraPadrao: string = "",
        tipoCarteiraPadrao: number = 0,
        variacaoCarteiraPadrao: string = "",
        tipoFormaCadastramento: number = 0,
        tipoImpressaoBoleto: number = 0,
        operacaoConta: string = ""
    ) {
        this.id = id;
        this.descricaoConta = descricaoConta;
        this.agencia = agencia;
        this.conta = conta;
        this.digitoConta = digitoConta;
        this.carteiraPadrao = carteiraPadrao;
        this.tipoCarteiraPadrao = tipoCarteiraPadrao;
        this.variacaoCarteiraPadrao = variacaoCarteiraPadrao;
        this.tipoFormaCadastramento = tipoFormaCadastramento;
        this.tipoImpressaoBoleto = tipoImpressaoBoleto;
        this.operacaoConta = operacaoConta;
    }
}